import {Box, Tab, Tabs} from "@mui/material";
import {useEffect} from "react";
import {useTranslation} from "react-i18next";
import {useRecoilState} from "recoil";
import SectionHeader from "../../../../util/component/SectionHeader";
import {Route, Routes, useLocation, useNavigate} from "react-router-dom";
import {FINE_TYPE_PARKING_FINES, FINE_TYPE_PENALTIES, STATE_ACTIVE_TAB} from "../../component/Constants";
import FinesList from "./FinesList";
import NotAuthorizedDialog from "../../../authentication/component/NotAuthorizedDialog";
import * as React from "react";
import {useHasScope} from "../../../../config/globalConfig";
import {SCOPE_FINES_MANAGEMENT, FINES_SCOPE_VIEW_CUSTOMER} from "../../component/utils/AuthConstants";

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

function TabPanel(props: TabPanelProps) {
    const {children, value, index, ...other} = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box>
                    {children}
                </Box>
            )}
        </div>
    );
}

const Fines = (props: any) => {
    const {t} = useTranslation(['finessecurity'], {keyPrefix: 'fines'});
    const hasScope = useHasScope;
    const [activeTab, setActiveTab] = useRecoilState(STATE_ACTIVE_TAB);
    const navigate = useNavigate();
    const location = useLocation();
    const rootFinesLocation = '/finessecurity/fines';
    const penaltiesLocation = '/finessecurity/fines/penalties';
    const finesAndPenaltiesLocation = '/finessecurity/fines/finesAndPenalties';
    function a11yProps(index: number) {
        return {
            id: `simple-tab-${index}`, 'aria-controls': `simple-tabpanel-${index}`,
        };
    }

    const changeTabAndPath = (newValue: any) => {
        setActiveTab(newValue);
        navigate(newValue ? finesAndPenaltiesLocation : penaltiesLocation);
    }

    useEffect(() => {
        if (location.pathname === rootFinesLocation || location.pathname === penaltiesLocation) {
            setActiveTab(0);
        } else if (location.pathname === finesAndPenaltiesLocation) {
            setActiveTab(1);
        }
    }, [])

    return (
       (hasScope(SCOPE_FINES_MANAGEMENT) || hasScope(FINES_SCOPE_VIEW_CUSTOMER)) ?
        <Box>
            <SectionHeader title={t('listHeader.title')}
                           subtitle={t('listHeader.subTitle')}/>

            <Box sx={{borderBottom: 1, borderColor: 'divider'}}>
                <Tabs value={activeTab} onChange={(_event, newValue: number) => changeTabAndPath(newValue)}>
                    <Tab label={t('tabs.penalties')} {...a11yProps(0)} />
                   {/* <Tab label={t('tabs.finesAndPenalties')} {...a11yProps(1)} />*/}
                </Tabs>
            </Box>
            <TabPanel value={activeTab} index={0}>
                <Routes>
                    <Route path="/" element={
                        <FinesList finesType={FINE_TYPE_PENALTIES}/>
                    }>
                    </Route>
                    <Route path="/penalties" element={
                        <FinesList finesType={FINE_TYPE_PENALTIES}/>
                    }>
                    </Route>
                </Routes>
            </TabPanel>
          {/*  <TabPanel value={activeTab} index={1}>
                <Routes>
                    <Route path="/finesAndPenalties" element={
                       <FinesList finesType={FINE_TYPE_PARKING_FINES}/>
                    }>
                    </Route>
                </Routes>
            </TabPanel>*/}
        </Box>
            : <NotAuthorizedDialog/>
    );
}

export default Fines;